import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./MetaField.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import TextInput from "../../../components/TextInput";

const MetaField = ({ className }) => {


  return (
    <Card
      className={cn(styles.card, className)}
      title="Meta Fields"
      classTitle="title-green"
      head={
        <Link
          className={cn("button-stroke button-small", styles.button)}
          to="/products/dashboard"
        >
          <Icon name="arrow-left" size="24" />
          <span>Back</span>
        </Link>
      }
    >
      <div className={styles.description}>
        <div className={styles.group}>
          <p className={styles.field}>Product Location</p>

          <TextInput
            className={styles.field}
            name="value2"
            type="text"
            placeholder="Value"
            required
          />

          <p className={styles.field}>Snowboard Binding Mount</p>
          <TextInput
            className={styles.field}
            name="value4"
            type="text"
            placeholder="Value"
            required
          />
        </div>
      </div>
    </Card>
  );
};

export default MetaField;
